<script>
export default {
  name: 'BaseInput',
}
</script>

<template>
  <el-input class="tamara-base-input" v-bind="$attrs" v-on="$listeners">
    <template v-slot:prefix>
      <slot name="prefix" />
    </template>
    <template v-slot:suffix>
      <slot name="suffix" />
    </template>
  </el-input>
</template>

<style lang="scss" scoped>
@import '@/styles/lavender/design.scss';

.tamara-base-input {
  &:hover {
    &::v-deep {
      .el-input__inner {
        border-color: var(--tamara-color-border-brand);
      }
    }
  }

  &::v-deep {
    &.is-disabled {
      .el-input__inner {
        color: #7e82ad;
        background-color: transparent;
        border: 1px solid var(--tamara-color-border);
      }
    }

    .el-input__inner {
      height: 40px;
      padding: 8px 12px;
      color: #16181d;
      background-color: #fff;
      border: 1px solid #ebeef4;
      border-radius: var(--tamara-border-radius-md);

      @extend .tamara-body-large;
    }

    &.el-input--medium {
      .el-input__inner {
        height: 48px;
      }
    }
  }
}
</style>
